<div class="col">
    <div class="game-card card overflow-hidden bg-body">
        <div class="row row-cols-1 g-0">
            <div class="col" style="height: 200px">
                <img src="/images/placeholder.png" class="img-fluid rounded-top w-100 h-100" style="object-fit: cover;">
            </div>
            <div class="col">
                <div class="card-body position-relative">
                    <div class="d-flex flex-row w-100 justify-content-between align-items-center">
                        <div class="d-flex flex-column align-items-start gap-1">
                            <h5 class="game-name text-nowrap"></h5>
                            <small class="joker-text"></span>
                        </div>
                        <i class="bi bi-lock fs-2 joker-lock"></i>
                    </div>
                    <div class="hold-progress bg-danger"></div>
                </div>
            </div>
        </div>
        
    </div>
</div>